// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --white: #FFFFFF;
  --white-secondary: #f4f4f4;
  --black: #000000;
  --bluee: #282c34;
  --lightblue: #61dafb;
  --lightgray: #eff0f1;
  ---gray100: #f3f4f6;
  --gray200: #dfe2e5;
  --gray300: #d1d5db;
  --gray400: #d3d3d3;
  --gray500: #6a737d;
  --gray600: #69788B;
  --gray700: #374151;
}

:root {
  --white: #FFFFFF;
  --white-secondary: #f4f4f4;
  --black: #000000;
  --bluee: #282c34;
  --lightblue: #61dafb;
  --lightgray: #eff0f1;
  ---gray100: #f3f4f6;
  --gray200: #dfe2e5;
  --gray300: #d1d5db;
  --gray400: #d3d3d3;
  --gray500: #6a737d;
  --gray600: #69788B;
  --gray700: #374151;
}

* {
  padding: 0;
  margin: 0;
}

body {
  font-family: "Open Sans", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

@keyframes loading {
  0% {
    background-color: var(---gray100);
  }
  100% {
    background-color: var(--gray300);
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/assets/styles/global.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;ACCJ;;ADdA;EACI,gBAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;ACiBJ;;AAxBA;EACI,UAAA;EACA,SAAA;AA2BJ;;AAxBA;EACI,+CAAA;EACA,mCAAA;EACA,kCAAA;AA2BJ;;AAvBA;EACI;IACI,iCAAA;EA0BN;EAxBE;IACI,gCAAA;EA0BN;AACF","sourcesContent":[":root {\n    --white: #FFFFFF;\n    --white-secondary: #f4f4f4;\n    --black: #000000;\n    --bluee: #282c34;\n    --lightblue: #61dafb;\n    --lightgray: #eff0f1;\n    ---gray100: #f3f4f6;\n    --gray200: #dfe2e5;\n    --gray300: #d1d5db;\n    --gray400: #d3d3d3;\n    --gray500: #6a737d;\n    --gray600: #69788B;\n    --gray700: #374151;\n\n}\n","\n          @import \"@assets/styles/_variables.scss\";\n        \n@import '_typography.scss';\n@import \"_variables.scss\";\n\n* {\n    padding: 0;\n    margin: 0;\n}\n\nbody {\n    font-family: \"Open Sans\", sans-serif !important;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n// common animaton used for skeleton loading\n@keyframes loading {\n    0% {\n        background-color:  var(---gray100);\n    }\n    100% {\n        background-color: var(--gray300);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
